import axios from '@/utils/request'

export default {
  // 2021-09-16
  findByTenantId() {
    return axios.get('/weddingDressHall/category/find-by-tenant-id')
  },
  // 2021-09-28
  productCategory() {
    return axios.get('/weddingDressHall/category/product-category')
  },
  // 2021-09-28
  serviceCategory() {
    return axios.get('/weddingDressHall/category/service-category')
  },
  // 2021-09-29
  findByName(params) {
    return axios.get('/weddingDressHall/category/find-by-name', params)
  },
  // 2021-09-29
  create(params) {
    return axios.post('/weddingDressHall/category', params)
  },
  // 2021-09-16
  insertBatch(params) {
    return axios.post('/weddingDressHall/category/insert-batch', params)
  },

  // 2021-09-16
  update(id, params) {
    return axios.put('/weddingDressHall/category/' + id, params)
  },
  // // 2021-05-22 
  // updateKey(id, params) {
  //   return axios.put('/categories/' + id + '/update-key', params)
  // },
  // // 2021-05-22 
  // findByKey(params) {
  //   return axios.get('/categories/find-by-key', params)
  // },
  // // 2021-05-21
  // batchShow(params) {
  //   return axios.put('/categories/batch-show', params)
  // },
  // // 2021-05-21
  // batchCancelShow(params) {
  //   return axios.put('/categories/batch-cancel-show', params)
  // },
  // 2021-09-16
  delete(id) {
    return axios.delete('/weddingDressHall/category/' + id)
  }

}

